const stripFileName = str =>
  typeof str === 'string' && str.indexOf('uploads/') === 0 ? str.split('/').pop() : str

module.exports = {
  stripFileName
}
